import React, { createContext, useContext } from "react";
import useSWR from "swr";
import { api } from "@/lib/api";

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

const fetcher = (url) => api.get(url).then((r) => r.data);

export function ContentProvider({ children }) {
  const { data: content } = useSWR("/content", fetcher, { revalidateOnFocus: false });
  return <ContentContext.Provider value={{ content }}>{children}</ContentContext.Provider>;
}
